// isiPad
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
})();
